// src/hooks/useUnsavedChanges.js
import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useUnsavedChanges = (hasUnsavedChanges) => {
  const [isPromptOpen, setIsPromptOpen] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const navigate = useNavigate();

  // Handle browser back/forward buttons and page refresh
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasUnsavedChanges) {
        event.preventDefault();
        event.returnValue = '';
        return '';
      }
    };

    if (hasUnsavedChanges) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }
  }, [hasUnsavedChanges]);

  const handleConfirmNavigation = useCallback(() => {
    setIsPromptOpen(false);
    setPendingNavigation(null);
  }, []);

  const handleCancelNavigation = useCallback(() => {
    setIsPromptOpen(false);
    setPendingNavigation(null);
  }, []);

  return {
    isPromptOpen,
    handleConfirmNavigation,
    handleCancelNavigation
  };
};